import React from 'react'
import styled from '@emotion/styled'
import { IconProps } from '../../models/IconProps'
const BaseComponent = ({ size = 24, tabIndex = -1, focusable = false, ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
      tabIndex={tabIndex}
      focusable={focusable}
      fill="currentColor"
      {...props}
    >
      <path d="M363.27,336H4.73L184,16Z" />
      <path d="M336,160a160.54,160.54,0,0,0-32.55,3.36l87.75,157L417.81,368H183.36C203.8,432.85,264.49,480,336,480c88.22,0,160-71.78,160-160S424.22,160,336,160Z" />
    </svg>
  )
}
export default styled(BaseComponent)`
  outline: none;
`
